import { render, staticRenderFns } from "./RoundRecordParts.vue?vue&type=template&id=9d785f92&scoped=true"
import script from "./RoundRecordParts.vue?vue&type=script&lang=ts"
export * from "./RoundRecordParts.vue?vue&type=script&lang=ts"
import style0 from "./RoundRecordParts.vue?vue&type=style&index=0&id=9d785f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d785f92",
  null
  
)

export default component.exports